export default "https://npm-assets.fiverrcdn.com/assets/@fiverr/freelance_impact_perseus/freelance-economy-2019.627cff2.pdf";